import styled from 'styled-components'
import { Table as BaseTable, Button, TableComponents } from '@sketch/components'

import { ReactComponent as DotIcon } from '@sketch/icons/dots-3-horizontal-24'

export const ListWrapper = styled.div`
  margin-top: 24px;
`

export const EmptyStateWrapper = styled.div`
  margin: auto;
  max-width: 250px;
`

export const Table = styled(BaseTable)`
  width: 100%;
` as typeof BaseTable

export const OptionsButton = styled(Button)`
  margin-left: auto;
  margin-right: 0;
  padding: 4px 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.B};

  &:hover {
    color: inherit;
  }
`

export const OptionsIcon = styled(DotIcon)`
  width: 24px;
`

export const MinimumTableCell = styled(TableComponents.TableCell)`
  width: 0;
`
